import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
    async getTripList(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettriplisting',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
  };
      async getActiveInactiveClientList() {
        try {
          let result = await axios({
            method: 'GET',
            'url': apiUrl.api_url + 'external/cargoclientkyc/getactiveinactiveclient',
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getPODImages(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettripdetails',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getSRList(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getsrlist',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }

      async getVehiclelist(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getvehiclelist',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }

      async createTrip(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/createtrip',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }

      async getTripDetails(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettripdetails',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async GetBookingAllocations(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getbookingallocations',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async createFirstMileTripAllocation(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/savetripallocation',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async createLastMileTripAllocation(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/savetripallocation',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async GetSelectedAWB(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getselectedawbfortrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }
      async RemoveFirstMileBooking(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/removetripallocation',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async RemoveLastMileBooking(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/removetripallocation',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getVehicleType(){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/external/mobile/getvehicletype',
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getTripData(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettripdata',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getTripAWB(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getawblistfortrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getTripMPS(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getmpslistfortrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async scanAWB(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/scanawb',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async scanMPS(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/scanmps',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getNotScanMps(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getnotscanmpsdata',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getMarkShortMps(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getmarkshortmpsdata',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async markShortMultipleMPS(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/markshortmultiplemps',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async validateMPSForNotScanned(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/validatempsfornotscanned',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async saveMPSDamgeOrPilferage(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/savempsdamgeorpilferage',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getDamageOrPilferageMpsData(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getdamageorpilferagempsdata',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async markAWBShort(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/markawbshort',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async ValidateAllocatedAWb(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/validateallocatedawb',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async startTrip(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/starttrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async ValidateEWBExpiry(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/validateewbexpiry',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async ValidateAWB(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/validateawb',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getAWBDataForCloseTrip(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getawblistforclosetrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getMPSDataForCloseTrip(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getmpslistforclosetrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getToBeScannedCountForMPS(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettobescannedcountformps',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getToBeScannedCountForAWB(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettobescannedcountforawb',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async GetTripSheetDetails(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/gettripsheetdetails',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async checkAllocationStatus(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/checkallocationstatus',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async checkAllDocumentScanned(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/checkalldocumentscanned',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getPODDetailAgainstAWB(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getpoddetailagainstawb',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }
      async getPODDetailAgainstTrip(input){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getpoddetailagainsttrip',
            'data': input,
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getBadPODReason(){
        try{
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/badpodreason',
          })
          return result;
        } catch(err){
          throw new Error(err)
        }
      }

      async getLRDetails(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/getlrdata',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async getAWBDetailsForLRCopy(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/getawbdetailsforlrcopy',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async closeTrip(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/closetrip',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async completeTripValidate(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/checkcompletetrip',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async savePOD(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/savepod',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async scanPallet(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/scanpallet',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getAllTripList(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getalltriplisting',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetAWBCharges(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getawbchargesdata',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async SaveAWBCharges(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/saveawbcharges',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetAwbCharges(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getawbcharges',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async uploadDocument(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/uploadDocument',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async uploadDocDocment(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/uploaddocdocment',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async UploadPODImage(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/uploadpodimage',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
  };
  async deletePodImages(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/deletepodimagefromS3',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async generatePresignUrl(input) {
    try {      
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'generatepresignurl',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  //this function is used to upload scanned image in to s3
  async UploadCameraBinaryImage(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/uploadcamerapodbinaryimage',
        // 'url': apiUrl.api_url + 'cargotripmanagement/uploadcamerapodbinaryimage',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  // this image is used to fetch scanned images got from scanner
  async fetchScannedImage(selectedScannerDevice) {
    try {
      let queryParams = {
        device: selectedScannerDevice,
      };
      let result = await axios({
        method: 'GET',
        'url': 'http://localhost:7000/scanner/scan',
        params:queryParams
        // 'data': {},
      })
      return result.data
    } catch (err) {
      throw new Error(err);
    }
  };
  async fetchInstalledScannerList() {
    try {
      let result = await axios({
        method: 'GET',
        'url': 'http://localhost:7000/scanner/list',
        // 'data': {},
      })
      return result.data
    } catch (err) {
      throw new Error(err);
    }
  };
      async removeMPSFromDeps(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/removempsfromdeps',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async UpdatePhysicalInvoice(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/updatephysicalinvoice',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async RemoveAWBCharges(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url +'cargotripmanagement/removeawbcharges',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async RemoveShortMps(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/removeshortmps',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async ftcCashDepositListing(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getftccashdepositlisting',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async UADShipmentListing(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/shipmentlisting',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async saveFTCDeposit(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/saveftccashdeposit',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };

      async SetUADCutOff(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/setuadcutoff',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }
      async GetDepositListing(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/getdepositlisting',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async MarkOtherConfiguration(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/markotherconfiguration',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }
      async getHubAccessList(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'external/getHubListaccessForUser',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetUADLogs(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/getuadlogs',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }
      async AcceptRejectDeposit(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/acceptrejecthubdeposit',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async reverseApprovedHubDeposit(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/reverseApprovedHubDeposit',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetUADReason(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/uadreasonlist',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }
      async ViewDepositSlip(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/viewdepositslip',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async MarkUAD(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/markuad',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      }
      async uploadDepositImage(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/uploaddepositimage',
            'data': input,
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetHublist() {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargomaster/gethublist',
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetUADReport(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/getuadreport',
            'data': input
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async SendUADEmail(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/senduademail',
            'data': input
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async GetAdminSettingconfig(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/getadminsettingconfig',
            'data': input
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getUadDataforraiselink(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/getuaddataforraiselink',
            'data': input
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async createb2bticketforuad(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/createb2bticketforuad',
            'data': input
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async downloaduadreport(input) {
        try {
          let result = await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'cargotripmanagement/UADconfig/downloaduadreport',
            'data': input
          })
          return result;
        } catch (err) {
          throw new Error(err);
        }
      };
      async getFTCAwb(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getftcawb',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };

    async UploadCollectibleDocument(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/uploadCollectibleDocument',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };

    async getFTCamount(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url':apiUrl.api_url + 'cargotripmanagement/getftcamount',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };

    async GetFTCShipmentDetails(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getftcshipmentdetails',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetCashMemoData(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getcashmemodata',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetFTCListing(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getradshipmentlisting',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GenerateCashMemo(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/generatecashmemo',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetFTCpaymentbreakup(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getftcpaymentbreakup',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async SendFTCPaymentEmail(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/sendemailconfirmation',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async ViewHubCashDepositSlip(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/viewcashdepositslip',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetFTCAwbForclosetrip(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url':apiUrl.api_url + 'cargotripmanagement/getftcawbforclosetrip',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async SaveCashMemo(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url':apiUrl.api_url + 'cargotripmanagement/savecashmemo',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async SaveCollectibles(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url':apiUrl.api_url + 'cargotripmanagement/savecollectible',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getSettlementReportListing(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url':apiUrl.api_url + 'cargotripmanagement/getsettlementreportlisiting',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetHublist() {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargomaster/gethublist',
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async gethubcashdetails(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/gethubcashdetails',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getBankListing(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getbankdetails',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async UpdateDestinationHub(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/updatedestinationhub',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async UploadDamageMPSImage(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/uploaddamagempsimage',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async MarkMPSDamage(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/markdamagemps',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetMPSDamageListing(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getmpsdamagelisting',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetDamageMPSImages(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getdamagempsimages',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetAllDamageMPSList(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getalldamagempslist',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetMPSDetailsForDamageMarking(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getmpsdetailsfordamagemarking',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async GetHubDetailsForDamageMarking(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'external/gethubdetail',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getBulkDeliveryConfig(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getbulkdeliveryconfig',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async updateBulkDeliveryStatus(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/updatebulkdeliverystatus',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async saveBulkDeliveryConfig(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/setbulkdeliveryconfig',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    }
    async checkHubMapping(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/checkhubmapping',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    }
    async getConsigneename(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getconsigneename',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    }
    async getConsigneeList(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getconsigneelist',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    }
    async CheckDTHEligiblity(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/checkdtheligibility',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async convertStanderedtoDTH(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/updatedthtriptag',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getTraceIP(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.iptracker_url + 'UserTracker',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getFtcReport(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getftcreport',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getFLMDashboardCount(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargoexternal/dashboard/flmdashboarddetails',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getFLMTabDetails(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargoexternal/dashboard/flmdashboarddetailview',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async RemoveFromShort(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/removefromshortage',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async checkExceptionalService(input){
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/checkexceptionalservice',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getZoneList(input) {
      this.input = {}
      try {
        let result = await axios({
          method: 'GET',
          'url': apiUrl.api_url + 'external/getzonelist',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getawbchargesdetails(input){
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getawbchargesdetails',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err)
      }
    };
    async getextrachargesdata(input){
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getextrachargesdata',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err)
      }
    }
    async fetchHubDataZonewise(input){
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'external/fetchhubdatazonewise',
          'data': input,
        })
        return result;
      } catch(err){
        throw new Error(err);
      }
    }
    async getRequestedpickupList(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/getpickuprequestlist',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getCreatedBylist() {
      try {
        let input ={};
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/getcreatedbylist',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async uploadCSVFile(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/pickuprequestcsvupload',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async validatecsvfile(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/validatecsvfile',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async PickupRequestSaveCSVData(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/pickuprequestsavecsvdata',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getPickupListForTrip(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/getpickuplistfortrip',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async AllocateRequestToTrip(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/allocaterequestpickuptotrip',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async AddedToTripRequest(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/addedtotriprequest',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async RemoveRequestFromTrip(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/removerequestfromtrip',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getAllRequestedpickupList(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/getallpickuprequestlist',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
  
    async getPickupDetails(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/getpickuprequestdetails',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
	async savePickupRequest(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'pickuprequest/saverequestpickup',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	};
	async getFMLMPODCount(input){
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'pod/flmbadpodcount',
				'data': input,
			})
			return result;
		} catch(err){
			throw new Error(err);
		}
	};
	async getFLMPodDetails(input){
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'pod/flmbadpoddetails',
				'data': input,
			})
			return result;
		} catch(err){
			throw new Error(err);
		}
	};
	async getallFLMPodDetails(input){
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'pod/getallpoddetails',
				'data': input,
			})
			return result;
		} catch(err){
			throw new Error(err);
		}
	};
	async getFLMDashboardpoddetails(input){
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'pod/getflmpoddetails',
				'data': input,
			})
			return result;
		} catch(err){
			throw new Error(err);
		}
	};
	async getBadPODReasonFromPodDashbaord(){
       try{
		 let result = await axios({
		     method: 'GET',
		    'url': apiUrl.api_url + 'pod/fetchpodremarks',
	    })
		   return result;
		} catch(err){
		 throw new Error(err)
		}
	}
	async uploadPodData(input){
		try{
		  let result = await axios({
			  method: 'POST',
			 'url': apiUrl.api_url + 'pod/uploadpoddata',
			 'data': input,
		 })
			return result;
		 } catch(err){
		  throw new Error(err)
		 }
	 }
	 async GetZoneForHub(input) {
		try {
		  let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'external/gethubdetail',
			'data': input,
		  })
		  return result;
		} catch (err) {
		  throw new Error(err);
		}
	  };
    async getAWBListAgainstPR(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pickuprequest/getawbagainstpr',
          'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getSRHelperList(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/getsrhelperlist',
		      'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async approveHelperRequest(input) {
      try {
        let result = await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'cargotripmanagement/helperrequestapproval',
			    'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
    async getFinanceCashDepositDetails(input) 
    {
      try {
        let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getfinancecashdepositdetails',
        'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
      };
    async getServerDateTime(input) 
    {
      try {
        let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'appvalidatetoken',
        'data': input,
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
      };
      async getPickupReqVisibilityRole(input) 
    {
      try {
        let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'pickuprequest/getpickupreqvisibilityrole',
        data:input
        })
        return result;
      } catch (err) {
        throw new Error(err);
      }
    };
  async getRouteDetails(input) {
    try {
      let result = await axios({
        method: "POST",
        url: apiUrl.api_url + "cargotripmanagement/getrequestroute",
        data: input,
      });
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveRouteRequest(input) {
    try {
      let result = await axios({
        method: "POST",
        url: apiUrl.api_url + "cargotripmanagement/addroutedetails",
        data: input,
      });
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveRouteMapping(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/saveroutemapping',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getRouteList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getroutelist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getRouteMappingList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getroutemappinglist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getAvilableRoute(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/avilablerouteforhub',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

async getRouteNameByRouteId(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url + 'cargotripmanagement/getroutenameaginstrouteid',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async getCreatedByList(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url + 'cargotripmanagement/getcreatedbylist',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async changeRouteMappingStatus(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url + 'cargotripmanagement/changeroutemappingstatus',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
  async changeStatus(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargotripmanagement/changestatus',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
}
async updateRouteMapping(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url + 'cargotripmanagement/updateroutemapping',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
  async updateRouteRequest(input) {
    try {
      let result = await axios({
        method: "POST",
        url: apiUrl.api_url + "cargotripmanagement/updateroutedetails",
        data: input,
      });
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getSRListRouteMapping(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getsrlistforroutemapping',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getCreatedByListiForRouteMapping(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getcreatedbylistforroutemapping',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getHubwisePincode(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getpincodehubmapping',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async uploadAutoAllocationFile(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/autoallocationupload',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async validateAutoAllocation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/validateautoallocationdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async pushValidAutoAllocation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/pushvalidallocationrecord',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getUploadedFileDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/GetRouteUploadDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getUploadedFileData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/GetRouteUploadData',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getAutoallocationConfig(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getautoallocationconfig',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async CheckDWSInscanbutton(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/dwsmanualcheck',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getPODCountDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'pod/getflmpodcount',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
   //Test Code
   async UploadPODImageTest(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/uploadpodimagetest',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };

  async getInvoiceData(input){
	try{
	  let result = await axios({
		method: 'POST',
		'url': apiUrl.api_url + 'cargotripmanagement/getinvoicedata',
		'data': input,
	  })
	  return result;
	} catch(err){
	  throw new Error(err)
	}
  };

  async saveInvoiceData(input){
	try{
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/saveinvoicedata',
		  'data': input,
		})
		return result;
	  } catch(err){
		throw new Error(err)
	}
  }
  async GetPaidFTCListing(input){
	try{
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/getpaidftclisting',
		  'data': input,
		})
		return result;
	  } catch(err){
		throw new Error(err)
	}
  }

  async getHTDEwabillsList(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargotripmanagement/gethtdshipmentlist',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async getPendingEwaybillsList(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargotripmanagement/gethtdshipmentlist',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async getmarkHTDReason(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargotripmanagement/gethtdreasonlist',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};

async markRemoveHTD(input) {
	try {
    let result = await axios.post(`${apiUrl.api_url}cargotripmanagement/markremovehtd`,input)
    .then(response => {
      return response.data
    })
    .catch(({response}) => {
      return response.data
    });
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async GetBulkCashMemoData(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url  + 'cargotripmanagement/getbulkcashmemodata',
      'data': input
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async UploadSignedCashMemo(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url  + 'cargotripmanagement/uploadsignedcashmemo',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async gets3signedurl(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url  + 'cargobooking/gets3signedurl',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async saveMarketVehicleRequest(input){
	try {
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/saverequestadhocvehicles',
		  'data': input,
		})
		return result;
	  } catch (err) {
		throw new Error(err);
	  }
}
async getRequestedMarketVehicle(input){
	try {
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/getrequestadhocvehicleslist',
		  'data': input,
		})
		return result;
	  } catch (err) {
		throw new Error(err);
	  }
}
async approveRejectRequest(input){
	try {
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/approverejectrequest',
		  'data': input,
		})
		return result;
	  } catch (err) {
		throw new Error(err);
	  }
}
async uploadProofOfApproval(input){
	try {
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/uploadproofofapproval',
		  'data': input,
		})
		return result;
	  } catch (err) {
		throw new Error(err);
	  }
}
async GetApprovalImages(input) {
	try {
	  let result = await axios({
		method: 'POST',
		'url': apiUrl.api_url + 'cargotripmanagement/getproofofuprovalimages',
		'data': input,
	  })
	  return result;
	} catch (err) {
	  throw new Error(err);
	}
  };
  async downloadMarketVehicleList(input){
	try {
		let result = await axios({
		  method: 'POST',
		  'url': apiUrl.api_url + 'cargotripmanagement/downloadadhocvehicleslist',
		  'data': input,
		})
		return result;
	  } catch (err) {
		throw new Error(err);
	  }
};
async getRolesList() {
	try {
		let result = await axios({
			method: 'GET',
			'url': apiUrl.api_url + 'external/getroleslist'
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async getApprovalHierarchyUsers(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargovehicleapprovalflow/getapprovalhierarchyusers',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};

async getUseragainstHub(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'external/GetHubUserList',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async createHerarchyUser(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargovehicleapprovalflow/createhierarchyuser',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async updateApprovalUsers(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargovehicleapprovalflow/updateapprovalhierarchyuser',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};

async getApprovallevelDetails(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargotripmanagement/getapprovalleveldetails',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};

async getAllRolesUsers(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargovehicleapprovalflow/getallrolesusers',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async savePoofOfApprovalImage(input) {
	try {
		let result = await axios({
			method: 'POST',
			'url': apiUrl.api_url + 'cargotripmanagement/saveapprovalimage',
			'data': input,
		})
		return result;
	} catch (err) {
		throw new Error(err);
	}
};
async getListForPodReupload(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url  + 'cargotripmanagement/getpodreuploadpendings',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
};
async saveReuploadedPod(input) {
  try {
    let result = await axios({
      method: 'POST',
      'url': apiUrl.api_url  + 'cargotripmanagement/savereuploadedpod',
      'data': input,
    })
    return result;
  } catch (err) {
    throw new Error(err);
  }
  };
  async fetchSrPodPendancyDetails(input){
    try{
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/fetchsrpodpendancydetails',
        'data': input,
      })
      return result;
    } catch(err){
      throw new Error(err)
    }
  }
async getApprovalConfiguredHub(input){
	try{
	  let result = await axios({
		method: 'POST',
		'url': apiUrl.api_url + 'cargotripmanagement/configuredapprovalhub',
		'data': input,
	  })
	  return result;
	} catch(err){
	  throw new Error(err)
	}
  }

  async uploadFinanceFtcCSVFile(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/financeReviewedFtcFileUpload',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async validateFinanceReviewCsvFile(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/validateFinanceReviewCsvFile',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async ftcSettlementSaveCSVData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/saveSettlementCSVData',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getFtcDigitalTransactions(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getftcdigitaltransactions',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getTotalAmount(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getftcdigitaltransactionsamount',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async fetchWayBillNumbers(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/ftc/fetchWayBillNumbers',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async savetdsdetailspaymentlink(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/savetdsdetailspaymentlink',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/services/firstAndLastmilemanagement.service.js